import gql from "graphql-tag";

export const UPDATE_SUPER_INTENDENT_PAVING_CALENDAR = gql`
  mutation updateSuperIntendentPavingCalendar($where: UpdateSuperIntendentPavingCalendarInput!) {
    updateSuperIntendentPavingCalendar(where: $where)
  }
`;